import { render, staticRenderFns } from "./BindWx.vue?vue&type=template&id=3df03536&scoped=true"
import script from "./BindWx.vue?vue&type=script&lang=js"
export * from "./BindWx.vue?vue&type=script&lang=js"
import style0 from "./BindWx.vue?vue&type=style&index=0&id=3df03536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df03536",
  null
  
)

export default component.exports